import { VStack } from '@cad-arc';
import { PersonsOrVehiclesSection } from '../../../../fr-entity-panels/components/persons-or-vehicles-section';
import {
    CorrectedLocation,
    EntityTypes,
    MergedEntityTypes,
} from '../../../../fr-entity-panels/types';
import { useIntegratedForm } from '../../../../forms/use-integrated-form';
import { BoloPanelFormType } from '@mark43/cad-api';
import { useBoloPanelMetadata } from '../../../../bolos/bolo-panel/state/bolo-panel-metadata-context';
import { FrBoloPanelAssociations } from './fr-bolo-details-associations';

export const FrBoloDetailsEntities = () => {
    const { form: boloForm } = useIntegratedForm<BoloPanelFormType>();
    const metadata = useBoloPanelMetadata();

    const { involvedPersons, involvedVehicles } = boloForm.watch();

    if (!metadata) {
        return null;
    }

    return (
        <VStack w="100%" justifyContent="flex-start" alignItems="flex-start" p={6} gap={2}>
            <PersonsOrVehiclesSection
                title="Involved Persons"
                entityType={EntityTypes.INVOLVED_PERSONS}
                mergedEntityType={MergedEntityTypes.INVOLVED_PERSONS}
                dexDetails={false}
                entitiesList={involvedPersons.map((p) => ({
                    ...p,
                    location: p.location ? (p.location as CorrectedLocation) : null,
                }))}
            />
            <PersonsOrVehiclesSection
                title="Vehicles"
                entityType={EntityTypes.VEHICLES}
                mergedEntityType={MergedEntityTypes.VEHICLES}
                dexDetails={false}
                entitiesList={involvedVehicles.map((v) => ({
                    ...v,
                    // Setting these to null for TS compatibility. BOLOs don't have tow vehicles, so this won't be an issue.
                    towedFromLocation: null,
                    towedToLocation: null,
                }))}
            />
            <FrBoloPanelAssociations />
        </VStack>
    );
};
